import { formatDate } from "../utils/format";

let en = {
  translations: {
    personal: "Private persons",
    business: "Business clients",

    searchbar: {
      input: "Search...",
      close: "Close",
      search: "Search",
    },

    pages: {
      complains: {
        title: "Complaints handling",
        subtitle:
          "Submit your complaint through the Bank’s branch network or through email in address:",
        email: "complaints@fibank.al",
        linkText:
          "Thorough information related to complaints handling procedures please visit the",
        link: "/informacioni-i-klientit/ankesa",
        linkText2: "link",
      },
      career: {
        label: "Career",
      },
      propertiesForSale: {
        label: "Properties for sale",
      },
      home: {
        selections: "Selections",
      },
      contact: {
        label: "Contacts",
        phoneNumberDescription: "For incoming calls outside the bank",
        tollFreeDescription: "Available for free",
        emailDescription: "Contact us by e-mail or fill out an",
        form: "inquiry form",
      },
      branches: {
        label: "Branches and ATMs",
      },
      about: {
        label: "About us",
        description:
          "15 years of sustainable development with focus on innovation and customer service",
      },
      news: {
        label: "News",
        latestNews: "Latest news",
        allNews: "All News",
      },
      help: {
        label: "Help",
      },
      search: {
        search: "Search",
        loading: "Loading...",
        results: "results",
        noResults: "No results found",
        searchParam: "Search parameter",
      },
      clientServices: {
        yourDetails: "Your details",
        title: "Fibank in your service",
        name: "Name",
        lastname: "Lastname",
        phoneNumber: "Phone number",
        email: "Email",
        fibankClient: "Are you a client of Fibank?",
        fibankClientOptions: {
          yes: "Yes",
          no: "No",
        },
        city: "City",
        type: "Request type",
        typeOptions: {
          individualOpportunity: "Financial Opportunity for individuals",
          businessOpportunity: "Financial Opportunity for businesses",
          creditCard: "Credit/Debit card",
          myPension: "My Pension",
          other: "Other",
        },
        description: "Description",
      },
      mortgageApplication: {
        step1: {
          stepTitle: "Step",
          title: "Calculator",
          subtitle:
            "You can use a loan calculator to calculate the approximate values ​​of your monthly installment.",
          currencyType: "Currency type:",
          mortgageType: "Loan Type:",
          chooseMortgage: "Choose loan type",
          mortgageSum: "Loan sum:",
          mortgagePeriods: "Loan period (months):",
          calculate: "Calculate",
          interesRate: "Interes rate:",
          monthlyPayments: "Monthly payments:",
          totalPayments: "Total to pay:",
          continue: "Continue",
        },
        step2: {
          stepTitle: "Step",
          title: "Loan Details",
          mortgageDetails: {
            title: "Extra details for your loan",
            mortgageType: "Loan type",
            mortgageTypeOptions: {
              consumerCredit: "Consumer Credit",
              mortgageLoan: "Loan Loan",
              ovd: "OVD",
              ovdWithSecurity: "Loan/OVD with security",
              ovdWithCashCollateral: "Loan/OVD with cash collateral",
            },
            usedFor: "Used for:",
            warrantorNumber: "Number of warrantors:",
          },
          employmentDetails: {
            title: "Employment details",
            employmentStatus: "Employment status:",
            employmentStatusOptions: {
              unemployed: "Unemployed",
              selfEmployed: "Self employed",
              student: "Student",
              retiree: "Retired",
              partTime: "Part time",
              fullTime: "Full time",
            },
            netIncome: "Net income:",
            netIncomeCurrency: "Currency:",
            otherMortgagePayments: "Monthly payment for other mortgages:",
            otherMortgagePaymentsCurrency: "Currency:",
            delayedPayments: "Delayed payments:",
          },
          clientDetails: {
            title: "Client Details",
            firstname: "Name:",
            lastname: "Lastname:",
            gender: "Gender:",
            birthdate: "Birthdate (Month/Day/Year):",
            clientType: "Client Type:",
            clientTypeOptions: {
              individual: "Individual",
              business: "Business",
            },
            email: "Email:",
            city: "City:",
            phoneNumber: "Phone number:",
            creditorStatus: "Status:",
            creditorStatusOptions: {
              single: "Single",
              engaged: "Engaged",
              married: "Married",
              divorced: "Divorced",
              widowed: "Widow",
            },
            creditorEducation: "Education:",
            numberOfDependents: "Dependent persons:",
          },
          otherDetails: {
            salaryInfo: "How do you get your salary:",
            salaryInfoOptions: {
              cash: "Cash",
              bank: "Bank",
            },
            knownThrough: "How did you find out about our services?",
            knownThroughOptions: {
              tv: "TV",
              radio: "Radio",
              socialMedia: "Social Media Facebook/Instagram/Google",
              relative: "Relative",
              staff: "Fibank staff",
              website: "Website",
              leaflet: "Leaflet",
              other: "Other",
            },
          },
          sendInfo: "Send Info",
        },
      },
      creditCardApplication: {
        step1: {
          stepTitle: "Step",
          title: "Parameters",
          subtitle:
            "Specify the desired limit and currency, then make your choice of card.",
          currencyType: "Currency type:",
          cardLimit: "Card limit:",
          goOn: "Go on",
          continue: "Continue",
        },
        step2: {
          stepTitle: "Step",
          title: "Request details",
          clientDetails: {
            title: "Detajet e klientit",
            firstname: "Emri:",
            lastname: "Mbiemri:",
            gender: "Gjinia:",
            birthdate: "Data e lindjes (Muaji/Dita/Viti):",
            email: "Adresa e Email-it:",
            city: "Qyteti:",
            phoneNumber: "Numri i telefonit:",
          },
        },
      },
      depositCalculator: {
        title: "Deposit Calculator",
        currency: "Currency",
        months: "Months",
        kind: "Deposit type",
        sum: "Sum",
        calculate: "Calculate",
        interest: "Interest",
        total: "Total amount",
        choose: "Choose",
      },
      properties: {
        APARTMENT: "Apartment",
        VILLA: "Villa",
        RESIDENTIAL_LAND: "Residential land",
        BUILDING: "Building",
        AGRICULTURAL_LAND: "Agricultural land",
        GARAGE: "Garage",
        SALE: "Sale",
        RENT: "Rent",
        choose: "Choose",
        transactionType: "Transaction type",
        propertyType: "Property type",
        price: "Price",
        city: "City",
        noResults: "No results found",
        properties: "Properties",
        filterParameters: "Filter parameters",
        all: "All",
        cityType: "Choose city:",
      },
    },
    notFoundPage: {
      status: 404,
      errorDescription: "We could not find the requested page!",
      errorMessage: "Home Page",
      suggestion: "Please go back to the home page.",
    },
    needs: {
      title: "Searching for:",
      button: {
        text: "Our suggestions",
      },
      items: {
        account: {
          text: "Account",
        },
        home: {
          text: "Home",
        },
        savings: {
          text: "Saving deposit",
        },
        credit: {
          text: "Loan",
        },
        travel: {
          text: "Travel",
        },
        furniture: {
          text: "Furniture",
        },
        card: {
          text: "Card",
        },
        insurance: {
          text: "Fibank Mobile",
        },
      },
    },
    plainCard: {
      buttonText: {
        text: "Read this article",
      },
    },
    contactPage: {
      header: {
        title: "Contact",
        subtitle:
          "with My Fibank mobile application your bank is everywhere with you",
      },
    },
    branchesPage: {
      hideText: "Hide",
      noResults: "No results found",
      title: "Branches and ATMs",
      filterByText: "Filter by:",
      allCitiesText: "All cities",
      selectTypeText: "Select a type",
      Branches: "Branches",
      ATM: "ATM",
      ATM_Cash_In: "ATM Cash-In",
    },
    exchange: {
      title: "Exchange rates",
      seeAllRates: "See all rates",
      buy: "Buy",
      sell: "Sell",
      unit: "Unit",
      notes: "Notes",
      note_1:
        "For amounts greater than 2000 Euros (or equivalent in other currencies) please contact the Treasury Department for a preferential rate.",
      note_2:
        "The official exchange rate is subject to changes reflecting international monetary markets.",
      note_3:
        "For fees and commissions paid from your bank account the exchange rate to be applied is the fixed exchange rate set by the Bank of Albania).",
    },
    bonds: {
      title: "Treasury Bill Calculator",
      issuer: "Issuer",
      type: "Type",
      isin: "ISIN",
      calcDate: "Calculation date",
      maturityDate: "Maturity date",
      remainingDays: "Remainging days",
      bidYield: "Bid Yield",
      askYield: "Ask Yield",
      price: "Price",
      interest: "Interest",
      buySell: "Buy/Sell",
      calculatorBuySell: "Buy/Sell Calculator",
      clientBuy: "Buy",
      clientSell: "Sell",
      nominalValueInLek: "Nominal value in Lek",
      calculate: "Calculate",
      note_1:
        "Fibank ju ofron mundesine te investoni ne letra me vlere te Qeverise Shqiptare me maturime te ndryshme dhe me interesat me te mira ne treg.",
      note_2:
        "Fibank blen Bono Thesari nga klientet deri ne 1 dite para dates se maturimit.",
      note_3: `Fibank shet Bono Thesari me afate te ndryshme deri ne maturim dhe me cmime mjaft konkuruese krahasuar me tregun e Letrave me Vlere.",
      note_4: "Blerje/Shitje Bono Thesari nga Fibank date ${formatDate(
        new Date()
      )}.`,
      note_5:
        "Tek tabela e mësipërme keni kuotimet me te cilat FIbank ble dhe shet Bono Thesari cmimin e se ciles ju mund ta llogaritni vete.",
      note_6:
        "Interesi I perfituar nga bonot e thesarit eshte objekt i tatimit mbi te ardhurat.",
      notSupported: "Veprimi nuk ofrohet.",
    },
    obligations: {
      title: "Treasury Bonds Calculator",
      issuer: "Issuer",
      type: "Type",
      isin: "ISIN",
      calcDate: "Calculation date",
      maturityDate: "Maturity date",
      remainingDays: "Remainging days",
      bidYield: "Bid Yield",
      askYield: "Ask Yield",
      price: "Price",
      interest: "Interest",
      buySell: "Buy/Sell",
      calculatorBuySell: "Buy/Sell Calculator",
      clientBuy: "Buy",
      clientSell: "Sell",
      nominalValueInLek: "Nominal value in Lek",
      calculate: "Calculate",
      accrued: "",
      coupon: "Coupon",
      bidPrice: "Buy price",
      askPrice: "Sell price",
      coupon6month: "Coupon paid every 6 months",
      priceToPay: "Price to pay",
      note_1: `Fibank ju ofron mundesine te investoni ne letra me vlere te Qeverise Shqiptare me maturime te ndryshme dhe me interesat me te mira ne treg.",
      note_2: "Blerje/Shitje Obligacione Thesari nga Fibank date ${formatDate(
        new Date()
      )}.`,
      note_3:
        "Fibank blen Obligacione Thesari nga klientet deri ne 1 dite para dates se maturimit.",
      note_4:
        "Fibank shet Obligacione Thesari me afate te ndryshme deri ne maturim dhe me cmime mjaft konkuruese krahasuar me tregun e Letrave me Vlere.",
      note_5:
        "Tek tabela mësipërme keni kuotimet me te cilat Fibank ble dhe shet Obligacione Thesari cmimin e se ciles ju mund ta llogaritni vete.",
      note_6:
        "Nese deshironi te shisni nje T-Bond i cili nuk gjendet ne listen e meposhtme ju lutem paraqituni prane degeve tona.",
      note_7:
        "Interesi I perfituar nga bonot e thesarit eshte objekt i tatimit mbi te ardhurat.",
    },
    quickFAQ: {
      title: "Frequently asked questions",
      seeAll: "See all",
    },
    errors: {
      required: "Required",
      mustBeNumber: "Must be a number",
      mustBeEmail: "Must be a valid email",
      mustBePhoneNumber: "Must be a valid phone number",
      mustBeDate: "Must be a date",
      mustBeInPast: "Date must not be in future",
    },
    tools: {
      title: "Online tools",
      subtitle: "take the opportunity to order products remotely",
      contact: "Fibank at your service",
      exchange: "Exchange rates",
      loan: "Loan application",
      creditCard: "Credit card application",
      deposit: "Deposits calculator",
      bond: "T-Bill Calculator",
      bill: "T-Bond Calculator",
    },
    footer: {
      bankAnywhere: "Bank from anywhere in the world",
      mobileAndOnlineBanking: "",
      tools: {
        title: "Tools",
      },
      products: {
        title: "Products and Services",
      },
      others: {
        title: "Others",
        personalData: "Personal Data",
        cookies: "Cookies Management",
        legalInformation: "Legal Information",
        covid2019: "Common Reporting Standard (CRS)",
      },
    },
    copyright: `Copyright © ${new Date().getFullYear()} Fibank`,
    buttonMenus: {
      login: "Login",
      learnMore: "Learn more",
      applyForLoan: "Apply for loan",
      loan: "Loan",
      card: "Cards",
      info: "Product information",
      apply: "Apply",
      myFibank: "Virtual Branch",
    },
    thankyouModal: {
      title: "Thank you",
      subtitle:
        "Your data is now being processed and you will be contacted soon.",
    },
    appBanner: {
      title: "With Fibank Mobile application, bank is in your hand.",
      description:
        "* Fibank Mobile application is user friendly and enables real-time banking from your phone.",
    },
    usefulLinks: {
      usefulLinks: "Useful Information",
      depositGuarantee: "Deposit guarantee",
      withdrawal: "Withdrawal of amounts",
    },
    jobVacancies: {
      closingDate: "Closing date",
    },
    contact: {
      centralOffice: "Headquarters",
      address: [
        '"Dëshmorët e Kombit" Boulevard',
        "Twin Towers, Tower no. 2, 12th Floor",
        "Postal Code 1019",
        "Tirana, Albania ",
      ].join("</br>"),
      contacts: "Contacts",
      contactCenter: "Contact",
      cardsDepartment: "Cards 24/7",
      virtualBanking: "Virtual Branch",
      cardsDepartmentDesc:
        "Contact phone number in case of lost or stolen debit/ credit card:",
      virtualBankingDesc: "Contacts:",
      departments: "Departments",
    },
    menu: {
      seeAll: "See all",
    },
    developedBy: "Developed by Togo.al",
  },
};

export default en;
